import { render, staticRenderFns } from "./WechatMaterialUpload.vue?vue&type=template&id=3239ac7c&scoped=true"
import script from "./WechatMaterialUpload.vue?vue&type=script&lang=js"
export * from "./WechatMaterialUpload.vue?vue&type=script&lang=js"
import style0 from "./WechatMaterialUpload.vue?vue&type=style&index=0&id=3239ac7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239ac7c",
  null
  
)

export default component.exports